export default __webpack_public_path__ + "static/media/remedios.ba55d7ab.svg";